"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RdfDereferencer = void 0;
const RdfDereferencerBase_1 = require("./RdfDereferencerBase");
/**
 * An RdfDerefencer can dereference URLs to RDF streams, using any RDF serialization.
 */
class RdfDereferencer extends RdfDereferencerBase_1.RdfDereferencerBase {
}
exports.RdfDereferencer = RdfDereferencer;
//# sourceMappingURL=RdfDereferencer-browser.js.map